import { render } from "./CicsForm.vue?vue&type=template&id=2bc995ea&scoped=true"
import script from "./CicsForm.vue?vue&type=script&lang=js"
export * from "./CicsForm.vue?vue&type=script&lang=js"

import "./CicsForm.vue?vue&type=style&index=0&id=2bc995ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc995ea"]])

export default __exports__